var navbar;
var triggerContainer;
var triggerLink;
var toggleButton;
var closeButton;
var lastMenuItem;

var mouseOutTimer;             // timer used to delay hiding of menu after mouse leaves
var mouseOutHideDelay = 10;  // time (in ms) before menu is closed after mouse leaves
var menuVisible = false;       // current visibility state of menu

window.addEventListener('DOMContentLoaded', function(e) {
  navbar = document.querySelector('nav');
  triggerContainers = document.querySelectorAll('nav > ul > li.megamenu-main');
  //triggerLink = triggerContainer.querySelector('nav > ul > li.megamenu-main > a');
  //toggleButton = triggerContainer.querySelector('nav > ul > li.megamenu-main > .toggle-button');
  closeButton = document.querySelector('.mega-menu .close-button');
  //lastMenuItem = document.querySelector('nav > ul > li.megamenu-main .column:last-of-type li:last-of-type > a');
  
  // Show the menu on mouse hover of the trigger
  triggerContainers.forEach(triggerContainer => {
    lastMenuItem = triggerContainer.querySelector('.header__featured-content a:last-of-type');
    triggerContainer.addEventListener('mouseover', function(e) {
      showMenu(triggerContainer);
      clearTimeout(mouseOutTimer);
    });
    toggleButton = triggerContainer.querySelector('.toggle-button');
    toggleButton.addEventListener('click', toggleMenu);
  })
  
  // Hide the menu when mouse hover leaves both the trigger and menu fly-out, but only after a short delay to help people jerky mouse movements (like those using head/eye trackers)
  triggerContainers.forEach(triggerContainer => {
    triggerContainer.addEventListener('mouseout', function(e) {
      mouseOutTimer = setTimeout(function() {
        hideMenu(triggerContainer);
      }, mouseOutHideDelay);
    });
  })


  triggerContainers.forEach(triggerContainer => {
    triggerContainer.addEventListener('keydown', triggerKeydownHandler);
  })

  toggleButton.addEventListener('click', toggleMenu);
  
  
  /* 
  // Hide the menu when the user tabs out of it
  triggerContainer.addEventListener('keydown', triggerKeydownHandler);
  
  // Toggle the menu when the trigger is activated
  toggleButton.addEventListener('click', toggleMenu);
  
  // Close the menu when the close button is clicked
  closeButton.addEventListener('click', hideMenu);
  
  // Close the menu AND return focus to the trigger when the close button is activted by keyboard
  closeButton.addEventListener('keydown', function(e) {
    if(e.key == 'Enter' || e.key == ' ') {
      e.preventDefault();
      hideMenu();
      toggleButton.focus();
    }
  }); */
  
  // Close the menu when the user activates something outside the navbar.
  document.body.addEventListener('click', handleBodyClick);
});


/**
  Menu visibility
*/
function showMenu(triggerContainer) {
  if(!triggerContainer) return
  // triggerLink.setAttribute('aria-expanded', true);
  toggleButton = triggerContainer.querySelector('nav > ul > li.megamenu-main > .toggle-button');
  toggleButton.setAttribute('aria-expanded', true);
  menuVisible = true;
}

function hideMenu(triggerContainer) {
  if(!triggerContainer) return
  toggleButton = triggerContainer.querySelector('.toggle-button');
  // triggerLink.setAttribute('aria-expanded', false);
  toggleButton.setAttribute('aria-expanded', false);
  menuVisible = false;
}

function toggleMenu(e) {
  let container = e.target.closest('.megamenu-main')
  if(menuVisible) {
    hideMenu(container);
  } else {
    showMenu(container);
  }
}


/**
  Event handlers
*/
function handleBodyClick(e) {
  // Hide the menu if the user clicks anywhere other than on the navbar or one of it's child menus
  if(!navbar.contains(e.target)) {
    hideMenu();
  }
}

function triggerKeydownHandler(e) {
  let contianer = e.target.closest('.megamenu-main');
  let lastMenuItem = contianer.querySelector('.mega-menu a.header__featured-content-a');
  // Hide the menu a keyboard user tabs out of it
  if((e.key === 'Tab' && !e.shiftKey && e.target === lastMenuItem) || e.key == 'Escape') {
    hideMenu(contianer);
    
    // Move focus back to the menu toggle button if Escape was pressed
    if(e.key == 'Escape') {
      toggleButton.focus();
    }
  }
}